// extracted by mini-css-extract-plugin
export default {"modalOverlay":"QD-z","modalContent":"RD-z","header":"SD-z","close":"TD-z"};